import { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { getScrollbarWidth } from './getScrollBarWidth';

const DEFAULT_SCROLLBAR_WIDTH = 15;
const CUSTOM_SCROLLBAR_WIDTH = 6;

export const Portal = ({ children }: { children: ReactNode }) => {
    const elRef = useRef<HTMLDivElement | null>(null);

    if (!elRef.current) elRef.current = document.createElement('div');

    useEffect(() => {
        const currentScrollbarWidth = getScrollbarWidth();
        const scrollBarWidth =
            currentScrollbarWidth === DEFAULT_SCROLLBAR_WIDTH
                ? CUSTOM_SCROLLBAR_WIDTH
                : currentScrollbarWidth;

        const el = elRef.current;

        if (el) {
            el.style.cssText += `background-color:rgba(0, 0, 0, 0.3);
                position:fixed;
                inset:0;
                z-index:1000;
                animation-name:fadeIn;
                animation-duration:0.4s;
                animation-timing-function:ease;
                transition: all 0.4s ease-out;
                top:0;
                bottom:0;
                left:0;
                right:0;`;
            document.body.appendChild(el);
            document.body.style.overflow = 'hidden';
            //document.body.style.marginRight = `${scrollBarWidth}px`;
            const header = document.getElementById('header');
            if (header) {
                header.style.right = `${scrollBarWidth}px`;
            }
        }

        return () => {
            if (el) {
                document.body.removeChild(el);
                document.body.style.overflow = 'auto';
                document.body.style.marginRight = '0';
                const header = document.getElementById('header');
                if (header) {
                    header.style.right = `0`;
                }
            }
        };
    }, []);

    return createPortal(<>{children}</>, elRef.current);
};
